export const porterShehzoreProducts = [
  {
    id: 'por-1',
    name: 'POR001',
    description: 'HEAD LAMP',
    partNumber: '92101-4B000 L / 92102-4B000 R',
    price: 48000,
    image:
      'https://public.readdy.ai/ai/img_res/15e54b6bbaeb4ee81c66d6a5ca136561.jpg',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-2',
    name: 'POR002',
    description: 'FOG LAMP',
    partNumber: '92201-4B000 L / 92202-4B000 R',
    price: 36000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20fog%20lamp%20light%20round%20shape%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-foglamp&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-3',
    name: 'POR003',
    description: 'CORNER LAMP',
    partNumber: '92301-4B001 L / 92302-4B001 R / 92301-4B101 L / 92302-4B101 R',
    price: 32000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20corner%20lamp%20indicator%20light%20amber%20lens%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-cornerlamp&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-4',
    name: 'POR004',
    description: 'TAIL LAMP',
    partNumber: '92401/2-4B000',
    price: 44000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20tail%20lamp%20light%20assembly%20red%20lens%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-taillamp&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-5',
    name: 'POR005',
    description: 'SIDE STEP',
    partNumber: '87441-4B000 L / 87442-4B000 R',
    price: 52000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20side%20step%20running%20board%20metal%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-sidestep&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-6',
    name: 'POR006',
    description: 'HANDLE',
    partNumber: '82650-4B000 L / 82660-4B000 R',
    price: 18000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20door%20handle%20chrome%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-handle&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-7',
    name: 'POR007',
    description: 'HEAD LAMP CASE',
    partNumber: '86431-4B000 L / 86441-4B000 R',
    price: 28000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20headlamp%20case%20housing%20black%20plastic%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-headlampcase&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-8',
    name: 'POR008',
    description: 'BUMPER',
    partNumber: '86510-4B000 / 86510-4B010',
    price: 86000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20front%20bumper%20chrome%20metal%20automotive%20part%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-bumper&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-9',
    name: 'POR036',
    description: 'FENDER',
    partNumber: '66310-4B600 L / 66320-4B600 R',
    price: 96000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20fender%20panel%20metal%20body%20part%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-fender&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
  {
    id: 'por-10',
    name: 'POR041',
    description: 'DOOR SILL PANEL',
    partNumber: '71355-43002 / 71151-43003',
    price: 38000,
    image:
      'https://readdy.ai/api/search-image?query=hyundai%20truck%20door%20sill%20panel%20trim%20piece%20on%20plain%20white%20background%20professional%20product%20photography&width=400&height=400&seq=por-doorsill&orientation=squarish',
    category: 'HYUNDAI PORTER SHEHZORE 99 PICK UP',
    inStock: true,
  },
];
